import { useState } from "react";
import { Box, Typography, Stack, Grid, Button } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FaMoneyBillWave, FaFileInvoiceDollar } from "react-icons/fa";
import { MdViewKanban } from "react-icons/md";
import Templete from "../../template/Template";
import ButtonCard from "../../components/ButtonCard/ButonCard";
import TabAsaas from "./TabAsaas";
import TabKanban from "./TabKanban";
import TabCategoriasPagar from "./TabCategoriasPagar";

type SecaoConfig = "asaas" | "kanban" | "categorias_pagar";

const titulosSecao: Record<SecaoConfig, string> = {
    asaas: "Configurações Asaas",
    kanban: "Configurações Kanban",
    categorias_pagar: "Categorias de Contas a Pagar",
};

export default function Configuracoes() {
    const [secao, setSecao] = useState<SecaoConfig | null>(null);

    return (
        <Templete menuActive="configuracoes">
            <Box sx={{ mb: 2 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <SettingsIcon color="primary" />
                    <Typography variant="h5" fontWeight="bold">
                        {secao ? titulosSecao[secao] : "Configurações"}
                    </Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                    {secao
                        ? "Ajuste os parâmetros desta seção"
                        : "Selecione uma seção para gerenciar as configurações do seu escritório"}
                </Typography>
            </Box>

            {secao === null && (
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={3}>
                        <ButtonCard
                            icon={<FaMoneyBillWave size={55} />}
                            title="ASAAS"
                            handle={() => setSecao("asaas")}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <ButtonCard
                            icon={<MdViewKanban size={55} />}
                            title="KANBAN"
                            handle={() => setSecao("kanban")}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <ButtonCard
                            icon={<FaFileInvoiceDollar size={55} />}
                            title="CONTAS A PAGAR"
                            handle={() => setSecao("categorias_pagar")}
                        />
                    </Grid>
                </Grid>
            )}

            {secao !== null && (
                <Box>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => setSecao(null)}
                        sx={{ mb: 2 }}
                    >
                        Voltar
                    </Button>
                    {secao === "asaas" && <TabAsaas />}
                    {secao === "kanban" && <TabKanban />}
                    {secao === "categorias_pagar" && <TabCategoriasPagar />}
                </Box>
            )}
        </Templete>
    );
}
